import EmberRouter from '@ember/routing/router';
import config from 'filter-wizard/config/environment';

export default class Router extends EmberRouter {
  location = config.locationType;
  rootURL = config.rootURL;
}

Router.map(function () {
  this.route('legacy', { path: '/Type' });
  this.route('legacy', { path: '/type' });
  this.route('legacy', { path: '/Specifications' });
  this.route('legacy', { path: '/specifications' });
  this.route('legacy', { path: '/ComponentSelection' });
  this.route('legacy', { path: '/componentselection' });
  this.route('legacy', { path: '/ComponentTolerances' });
  this.route('legacy', { path: '/componenttolerances' });
  this.route('legacy', { path: '/FinalResults' });
  this.route('legacy', { path: '/finalresults' });
});
